import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import SEO from '../../components/seo';
import PageHeader from '../../components/pageHeader';
import Style from './style.module.scss';
import SettingsModal from '../../components/cookiesPopup/components/settingsModal';

const CookiePolicy = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const beforeTableParagraphs = t('cookiesPage.beforeTableParagraphs', {
    returnObjects: true,
  });

  const afterTableParagraphs = t('cookiesPage.afterTableParagraphs', {
    returnObjects: true,
  });

  const tableItems = t('cookiesPage.table.tableItems', {
    returnObjects: true,
  });

  const showCookiePopup = () => {
    setIsModalVisible(true);
  };

  return (
    <>
      <SEO pageKey="cookiePolicy" />
      <PageHeader title={t('cookiePolicy')} />
      <div className={Style.section}>
        <div className={Style.container}>
          <div className={Style.policyWrapper}>
            {Object.values(beforeTableParagraphs).map((text, index) => (
              <div className={Style.policyLine} key={index}>
                {text.title && <h2 className={Style.lineTitle}>{t(text.title)}</h2>}

                {text.paragraph && (
                  <p
                    className={Style.lineText}
                    dangerouslySetInnerHTML={{
                      __html: t(text.paragraph),
                    }}
                  />
                )}
              </div>
            ))}
          </div>
          <div className={Style.tableScroll} aria-label="Scrollable table">
            <table className={Style.table}>
              <thead>
                <tr>
                  <th>{t('cookiesPage.table.title.t1')}</th>
                  <th>{t('cookiesPage.table.title.t2')}</th>
                  <th>{t('cookiesPage.table.title.t3')}</th>
                  <th>{t('cookiesPage.table.title.t4')}</th>
                  <th>{t('cookiesPage.table.title.t5')}</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(tableItems).map(([tableKey, tableObj]) => (
                  <tr key={tableKey}>
                    {Object.entries(tableObj).map(([itemKey, value]) => (
                      <td key={itemKey}>{value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={Style.policyWrapper}>
            {Object.values(afterTableParagraphs).map((text, index) => (
              <div className={Style.policyLine} key={index}>
                {text.title && <h2 className={Style.lineTitle}>{t(text.title)}</h2>}

                {text.paragraph && (
                  <p className={Style.lineText}>
                    <Trans
                      i18nKey={text.paragraph}
                      components={[
                        <button
                          className={Style.btn}
                          key={0}
                          type="button"
                          onClick={() => showCookiePopup()}
                        >
                          {0}
                        </button>,
                        <a
                          key={1}
                          href="https://tools.google.com/dlpage/gaoptout"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {1}
                        </a>,
                        <a
                          key={2}
                          href="https://support.google.com/chrome/answer/95647?hl=en"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {2}
                        </a>,
                      ]}
                    />
                  </p>
                )}
                {text.list && (
                  <ul className={Style.lineText}>
                    <Trans
                      i18nKey={text.list}
                      components={[
                        <Link key={0} to={t('routes.gdpr')}>
                          {0}
                        </Link>,
                      ]}
                    />
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <SettingsModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setIsActive={setIsActive}
      />
    </>
  );
};

export default CookiePolicy;
